<template>
  <transition name="common-confirm-fade">
    <div v-if="visible" class="common-confirm-mask" @click.self="handleMaskClick">
      <div class="common-confirm-panel" role="dialog" aria-modal="true" :aria-label="title">
        <div class="common-confirm-title">{{ title }}</div>
        <div v-if="message" class="common-confirm-message">{{ message }}</div>
        <div class="common-confirm-actions">
          <button v-if="showCancel" type="button" class="common-confirm-button" @click="$emit('cancel')">
            {{ cancelText }}
          </button>
          <button type="button" class="common-confirm-button common-confirm-button--primary" @click="$emit('confirm')">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    showCancel: { type: Boolean, default: true },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '请确认操作' },
    message: { type: String, default: '' },
    confirmText: { type: String, default: '确认' },
    cancelText: { type: String, default: '取消' },
    closeOnClickMask: { type: Boolean, default: false },
    closeOnPressEscape: { type: Boolean, default: true }
  },
  watch: {
    visible: {
      immediate: true,
      handler (value) {
        const action = value ? 'addEventListener' : 'removeEventListener'
        document[action]('keydown', this.handleKeydown)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    handleMaskClick () {
      if (this.closeOnClickMask) this.$emit('cancel')
    },
    handleKeydown (event) {
      if (this.visible && this.closeOnPressEscape && event.key === 'Escape') this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.common-confirm-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--common-mask-color);
}
.common-confirm-panel {
  width: 84%;
  max-width: 440px;
  overflow: hidden;
  border-radius: var(--common-border-radius);
  background: var(--common-surface-color);
  box-shadow: 0 2px 8px var(--common-shadow-color);
}
.common-confirm-title {
  padding: 22px 22px 10px;
  color: var(--common-text-color);
  font-size: 18px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.common-confirm-message {
  padding: 0 22px 22px;
  color: var(--common-text-secondary-color);
  font-size: 15px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}
.common-confirm-actions {
  display: flex;
  border-top: 1px solid var(--common-divider-color);
}
.common-confirm-button {
  flex: 1;
  border: 0;
  background: var(--common-surface-color);
  padding: 15px 8px;
  color: var(--common-text-secondary-color);
  font: inherit;
  cursor: pointer;
}
.common-confirm-button + .common-confirm-button {
  border-left: 1px solid var(--common-divider-color);
}
.common-confirm-button--primary {
  color: var(--primary-color);
  font-weight: 600;
}
.common-confirm-button:active {
  background: var(--common-active-color);
  color: var(--common-surface-color);
}
.common-confirm-fade-enter-active,
.common-confirm-fade-leave-active {
  transition: opacity .2s ease;
}
.common-confirm-fade-enter,
.common-confirm-fade-leave-to {
  opacity: 0;
}
</style>
